import { lazy, Suspense, useEffect } from 'react';

import { isCashierProcessingPath } from '@nxplatform/spa-service/helpers/cashierProcessing';
import { BlockedPage } from '@nxplatform/spa-service/pages/blocked.page';
import { useApplicationBootHook } from '@nxplatform/spa-service/services/application-boot.hook';
import { AvailabilityStatus } from '@nxplatform/spa-service/services/base-window-setup.service';

import { environment } from '../environments/environment';

import DesktopModule from './pages/desktop.module';
import MobileModule from './pages/mobile.module';


import(
  /* webpackPreload: true */
  '@nxplatform/platform-common/platform-routes'
);

const CashierPageProcessing = lazy(() => import('./pages/cashier-processing/cashier-processing'));

const pageStatusToRender = [AvailabilityStatus.ok, AvailabilityStatus.notFound];

export function App() {
  const { config } = useApplicationBootHook(environment);


  useEffect(() => {
    // translations not dynamic -> we need remove it from libs
    if (window.isMobile) {
      // @ts-ignore
      import(/* webpackPreload: true */ 'apps/mobile/src/styles-ee.scss');
    }
    if (!window.isMobile) {
      // @ts-ignore
      import('apps/platform/src/styles-ee.scss');
    }

  }, []);


  if (isCashierProcessingPath) return (
    <Suspense>
      <CashierPageProcessing />
    </Suspense>
  );

  return (
    <>
      {config && (
        <>
          {pageStatusToRender.includes(config.status) && (
            <div id={'main-page'}>
                {window.isMobile && (
                  <MobileModule />
                )}
                {!window.isMobile && (
                  <DesktopModule />
                )}
            </div>
          )}
          <Suspense>
            <>
              {config.status === AvailabilityStatus.blocked
                && <BlockedPage payload={config.payload} />}
              {config.status === AvailabilityStatus.maintenance
                && <BlockedPage payload={config.payload} />}
            </>
          </Suspense>
        </>
      )}
    </>
  );
}

export default App;
